/*
 *  模型选项
 */
import React from 'react';
import { observer } from 'mobx-react-lite';
import ModelSearch from '@/components/model-search';

const ModelChoice = observer(props => {
  return (
    <div 
      className={[
        "flex flex-col w-768px h-700px pt-32px max-h-screen",
      ]}
      style={props.choiceStyle || {}}
    >
      <ModelSearch
        {...props}
        scene={'modal'}
        className="h-0 flex-grow"
      />
    </div>
  );
});

export default ModelChoice;
